export default __webpack_public_path__ + "static/barfplan-blog-promo-small@3x-a4751fd8e0241b0f382c47ae904ac618.webp";